import { NavMenu } from '@shopify/app-bridge-react';
import { Link } from "react-router-dom";
import Language from "../../i18n/Language";
const t = Language;

const NavMenuList = () => {

    return (
        <NavMenu>
            <Link rel="home" to="/dashboard">Home</Link>
            <Link to="/website-check">{t("SEO Checker")}</Link>
            <Link to="/speedOpt">{t("Speed Optimization")}</Link>
            <Link to="/content-seo">{t("AI Content Creation")}</Link>
            <Link to="/on-page-seo">{t("Content Optimization")}</Link>
            <Link to="/technicalSEO">{t("Technical SEO")}</Link>
            <Link to="/keywordRearch">{t("Keyword Research")}</Link>
            <Link to="/backlinks">{t("Link Building")}</Link>
            <Link to="/plan">{t("Pricing")}</Link>
            <Link to="/settings">{t("Settings")}</Link>
        </NavMenu>
    );
}

export default NavMenuList;